import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SweetalertService {

  constructor() { }

  success(_title: string, html?: any) {
    let conf: any = {};

    conf.icon = 'success';
    conf.title = _title;
    conf.showConfirmButton = true;
    conf.confirmButtonText = 'ยืนยัน';
    conf.confirmButtonColor = '#3DBBE6';

    if (html) conf.html = html;

    Swal.fire(conf);
  }

  successResponse(_title: string, html?: any) {
    let conf: any = {};

    conf.icon = 'success';
    conf.title = _title;
    conf.showConfirmButton = true;
    conf.confirmButtonText = 'ยืนยัน';
    conf.confirmButtonColor = '#3DBBE6';
    
    if (html) conf.html = html;

    return Swal.fire(conf);
 }

  error(_title: string, _text?: string): Promise<any> {
    return new Promise((resolve: any) => {
      Swal.fire({
        icon: 'error',
        title: _title,
        html: _text,
        showConfirmButton: true,
        confirmButtonText: 'ยืนยัน',
        confirmButtonColor: '#1ab3b1',
      }).then(res => {
        resolve();
      });
    });
  }

  warning(_title: string, _text?: string): Promise<any> {
    return new Promise((resolve: any) => {
      Swal.fire({
        icon: 'warning',
        title: _title,
        html: _text,
        showConfirmButton: true,
        confirmButtonText: 'ยืนยัน',
        confirmButtonColor: '#1ab3b1',
      }).then(res => {
        resolve();
      });
    });
  }

  confirm(tile: string, txt: string): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: tile,
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab3b1',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  confirmInput(tile: string, txt: string): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: tile,
        text: txt,
        input: 'text',
        inputPlaceholder:'แสดงความคิดเห็น',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonColor: '#1ab3b1',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          resolve(result.value);
        } else {
          reject();
        }
      });
    });
  }

  confirmCustom(tile: string, txt: string, confirmbtntxt: string, cancelbtntxt: string): Promise<any> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: tile,
        text: txt,
        // icon: 'warning',
        showCancelButton: true,
        // confirmButtonColor: '#1ab3b1',
        // cancelButtonColor: '#d33',
        confirmButtonText: confirmbtntxt,
        cancelButtonText: cancelbtntxt,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }
}
